import React from 'react';
import { range } from 'ramda';
import { gql, useQuery } from '@apollo/client';

import { AvailableYearsQuery } from '#types/generated/graphql';

import YearsContext from '../contexts/YearsContext';

const Years: React.FC<{}> = ({ children }) => {
  const { data, error } = useQuery<AvailableYearsQuery>(
    gql`
      query AvailableYears($releaseNames: [String]!) {
        releases(releaseNames: $releaseNames) {
          id
          year
          releaseDate
        }
      }
    `,
    {
      variables: {
        releaseNames: ['wur'],
      },
    },
  );

  if (error) {
    throw new Error('Error while receiving WUR available years');
  }

  const { releases: wurAvailableYears } = data || { releases: [] };

  const getReleaseYear = (startDate: number) =>
    range(startDate, new Date().getFullYear() + 2).map((year) => ({
      year,
    }));

  return (
    <YearsContext.Provider
      value={{
        availableYears: {
          wur: wurAvailableYears,
          sed: getReleaseYear(2015),
          sdg: getReleaseYear(2020),
          reputation: getReleaseYear(2015),
          japanrankingdashboard: getReleaseYear(2015),
          'new-data': getReleaseYear(2015),
          cid: getReleaseYear(2015),
          latam: getReleaseYear(2015),
          crd: getReleaseYear(2015),
          explore: getReleaseYear(2015),
          resources: getReleaseYear(2015),
          'wur-reporter': getReleaseYear(2015),
        },
      }}
    >
      {children}
    </YearsContext.Provider>
  );
};

export default Years;
